export enum WebSiteAction {
    Refresh = 'refresh',
}
